<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import {useMutation, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast, successToast} from "@/composables/useToasts";

defineProps({
  activityLogId: {
    required: true,
    type: Number,
  },
});

const emit = defineEmits(['close', 'confirm']);

const handleClose = () => {
  emit('close');
};

const queryClient = useQueryClient();

const {mutate: handleConfirm, isPending} = useMutation({
  mutationFn: (activityLogId) => axios.post(`/ajax/v2/seo-agent-activity-log/${activityLogId}/undo`),
  onSuccess: () => {
    successToast('Change reverted successfully.');
  },
  onError: (error) => {
    const {message} = error.response.data
    errorToast(message ?? 'Something went wrong please try again later.');
  },
  onSettled: () => {
    queryClient.invalidateQueries(['activityLogs']);
    emit('close');
  },
});
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="handleClose"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <KitIcon
            class="tw-w-[88px]"
            state="sad"
          />

          <ModalHeader>
            <ModalHeading>Revert change</ModalHeading>

            <ModalSubText>
              Are you sure you want to revert this change? This action cannot be undone and will restore the content to its previous state.
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>

        <div class="tw-flex tw-justify-between">
          <div class="tw-flex tw-items-center tw-gap-2">
            <svg-vue
              icon="icons/warning"
              class="tw-w-6 tw-h-6 tw-text-neutral tw-flex-shrink-0"
            />
            <span class="tw-text-base tw-text-neutral">This cannot be undone</span>
          </div>
          <div class="tw-flex tw-items-center tw-justify-end tw-gap-4">
            <DefaultButton
              variant="primary-inverted"
              :disabled="isPending"
              @click="handleClose"
            >
              Cancel
            </DefaultButton>
            <DefaultButton
              variant="danger"
              :disabled="isPending"
              @click="handleConfirm(activityLogId)"
            >
              Revert
            </DefaultButton>
          </div>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
